import React from 'react';
import NavBar from 'shared/NavBar/NavBar';
import Footer from 'shared/Footer/Footer';
import { Column, Container, Grid } from 'lmc-ui-library';
import useBodyClass from 'helpers/hooks/useBodyClass';

import style from './Firms.module.scss';

type Props = {};

const FirmsTemplate: React.FC<Props> = ({ children }) => {
  useBodyClass(...style['firms'].split(' '));

  return (
    <>
      <header>
        <NavBar fixed={false} />
      </header>
      <div>
        <Container p={3} pt={5} className={style.container}>
          <Grid cols={12} mb={0} p={0}>
            <Column md={12} sm={12} xs={12}>
              {children}
            </Column>
          </Grid>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default FirmsTemplate;
